// It takes date in british format DD/MM/YYYY and returns YYYY-MM-DD
export const fromDPFormat = (d: string) => d.split('/').reverse().join('-');

// It takes string date format YYYY-MM-DD and returns  in british format DD/MM/YYYY
export const toDPFormat = (d: string) => d.split('-').reverse().join('/');
